import axios, {AxiosResponse} from 'axios'
import {ID, WoosatTelecomResponse, Response} from '../../../../../_metronic/helpers'
import {RolePermission, RolesPermissionsQueryResponse} from './_models'
import toast from 'react-hot-toast'

const API_URL = process.env.REACT_APP_THEME_API_URL
const ROLEPERMISSION_URL = `${API_URL}/admin/roles`
const GET_ROLESPERMISSIONS_URL = `${API_URL}/admin/roles`

const getRolesPermissions = (query: string): Promise<RolesPermissionsQueryResponse | WoosatTelecomResponse<RolePermission[]>> => {
  return axios
    .get(`${GET_ROLESPERMISSIONS_URL}?${query}`)
    .then((d: AxiosResponse<WoosatTelecomResponse<RolePermission[]>>) => {
      return d.data
    })
}

const getRolePermissionById = async (id: ID): Promise<RolePermission> => {
  try {
    const { data } = await axios.get(`${ROLEPERMISSION_URL}/${id}`)
    const roleData = data?.data?.role

    // Extract roles, permissions, and all_permissions as needed
    return {
      id: roleData.id,
      name: roleData.name,
      permissions: roleData.permissions?.map((perm: any) => perm.id) || [],
      all_permissions: roleData.all_permissions || [],
    }
  } catch (error: any) {
    console.log('Error: ', error.message)
    return {
      id: undefined,
      name: '',
      permissions: [],
      all_permissions: [],
    }
  }
}
const createRolePermission = (role: RolePermission): Promise<RolePermission | undefined> => {
  const payload: Record<string, any> = {};

  // Construct the payload
  Object.entries(role).forEach(([key, value]) => {
    payload[key] = value;
  });

  console.log("Payload being sent:", payload); // Debugging

  return axios
    .post(ROLEPERMISSION_URL, payload, {
      headers: {
        'Content-Type': 'application/json', // Set the content type to JSON
      },
    })
    .then((response: any) => {
      if (response.data.success) {
        toast.success(response.data.message, { position: 'top-right' });
      } else {
        toast.error(response?.data?.message, { position: 'top-right' });
      }
      return response.data;
    })
    .then((response: Response<RolePermission>) => response.data)
    .catch((error) => {
      console.error("Request Error:", error);
      throw error;
    });
};



const updateRolePermission = (role: RolePermission): Promise<RolePermission | undefined> => {
  const payload: Record<string, any> = {};

  // Construct the payload
  Object.entries(role).forEach(([key, value]) => {
    payload[key] = value;
  });

  console.log("Payload being sent for update:", payload); // Debugging

  return axios
    .put(`${ROLEPERMISSION_URL}/${role.id}`, payload, {
      headers: {
        'Content-Type': 'application/json', // Set the content type to JSON
      },
    })
    .then((response: any) => {
      if (response.data.success) {
        toast.success(response.data.message, { position: 'top-right' });
      } else {
        toast.error(response?.data?.message, { position: 'top-right' });
      }
      return response.data;
    })
    .then((response: Response<RolePermission>) => response.data)
    .catch((error) => {
      console.error("Request Error:", error);
      throw error;
    });
};



const deleteRolePermission = (roleId: ID): Promise<void> => {
  return axios.delete(`${ROLEPERMISSION_URL}/${roleId}`).then((response) => {
    if(response.data.success == true){
      toast.success(response?.data?.message,{position:'top-right'})
    }else{
      toast.error(response?.data?.message,{position:'top-right'})
    }
  })
}

const deleteSelectedRolesPermissions = (roleIds: Array<ID>): Promise<void> => {
  const requests = roleIds.map((id) => axios.delete(`${ROLEPERMISSION_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getRolesPermissions,
  deleteRolePermission,
  deleteSelectedRolesPermissions,
  getRolePermissionById,
  createRolePermission,
  updateRolePermission,
}
